import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxComponent } from './checkbox.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { IconModule } from '../../icon/icon-module';
import { TooltipsModule } from 'src/app/project/features/tooltip/tooltips.module';
import { IconsModule } from '../../icons/icons.module';

@NgModule({
  declarations: [CheckboxComponent],
  imports: [CommonModule, PipesModule, IconModule, TooltipsModule, IconsModule],
  exports: [CheckboxComponent],
})
export class CheckboxModule {}
